import { Routes } from '@angular/router';
import { AppRoutes } from './app.app-manager-routes';
import { NoRouteDataAutoLoginPartialRouteGuardFunction } from './authorization/auth-guard/auth.guard';
import { AnaClubEMC } from './emc/ana-club.emc';
import { AnagraficheEMC } from './emc/anagrafiche.emc';
import { AntidopingEMC } from './emc/antidoping.emc';
import { CalendarioEMC } from './emc/calendario.emc';
import { CorsiEMC } from './emc/corsi.emc';
import { DiplomiEMC } from './emc/diplomi.emc';
import { FattureEMC } from './emc/fatture.emc';
import { GestioneEMC } from './emc/gestione.emc';
import { GiudiceProfiloEMC } from './emc/giudice-profilo.emc';
import { GiudiciEMC } from './emc/giudici.emc';
import { HomeEMC } from './emc/home.emc';
import { NormalizzazioneEMC } from './emc/normalizzazione.emc';
import { PagamentiEMC } from './emc/pagamenti.emc';
import { ProfiloUtenteEMC } from './emc/profilo-utente.emc';
import { RendicontazioneEMC } from './emc/rendicontazione.emc';
import { SecEMC } from './emc/security.emc';
import { ServiziEMC } from './emc/servizi.emc';
import { routeInfo } from './routing/route-info';
const routes: Routes = [
  // { path: '', component: HomeComponent, pathMatch: 'full' },

  { path: '', redirectTo: AppRoutes.Home.url, pathMatch: 'full' },
  {
    path: 'callback',
    loadComponent: () =>
      import('./authorization/auth-callback/auth-callback.component').then((m) => m.AuthCallbackComponent)
  },
  {
    path: AppRoutes.AnteprimaAntidoping.url + '/:controllo/:figura/:verbale',
    data: { ...routeInfo([AppRoutes.AnteprimaAntidoping]) },
    loadComponent: () =>
      import('./components/antidoping-anteprime/antidoping-anteprime.component').then(
        (m) => m.AntidopingAnteprimeComponent
      )
  },
  {
    path: AppRoutes.Home.url,
    data: { ...routeInfo([AppRoutes.Home], HomeEMC) },
    loadComponent: () => import('./modules/home/home.component').then((m) => m.HomeComponent),
    canActivate: [NoRouteDataAutoLoginPartialRouteGuardFunction]
  },
  {
    path: AppRoutes.Calendario.url,
    data: { ...routeInfo([AppRoutes.Calendario], CalendarioEMC) },
    canActivate: [NoRouteDataAutoLoginPartialRouteGuardFunction],
    loadComponent: () =>
      import('./modules/calendario/components/home/home-calendario/home-calendario.component').then(
        (m) => m.HomeCalendarioComponent
      ),
    loadChildren: () => import('./modules/calendario/calendario-routing.module').then((m) => m.routes)
  },
  {
    path: AppRoutes.Security.url,
    data: { ...routeInfo([AppRoutes.Security], SecEMC) }, // component: HomeInnerComponent
    canActivate: [NoRouteDataAutoLoginPartialRouteGuardFunction],
    loadChildren: () => import('./modules/security/security-routing.module').then((m) => m.routes)
  },
  {
    path: AppRoutes.Anagrafiche.url,
    data: { ...routeInfo([AppRoutes.Anagrafiche], AnagraficheEMC) },
    loadComponent: () =>
      import('./modules/home-inner/components/home-inner/home-inner.component').then((m) => m.HomeInnerComponent),
    canActivate: [NoRouteDataAutoLoginPartialRouteGuardFunction],
    loadChildren: () => import('./modules/anagrafiche/anagrafiche-routing.module').then((m) => m.routes)
  },
  {
    path: AppRoutes.Gestione.url,
    data: { ...routeInfo([AppRoutes.Gestione], GestioneEMC) },
    loadComponent: () =>
      import('./modules/home-inner/components/home-inner/home-inner.component').then((m) => m.HomeInnerComponent),
    canActivate: [NoRouteDataAutoLoginPartialRouteGuardFunction],
    loadChildren: () => import('./modules/gestione/gestione-routing.module').then((m) => m.routes)
  },
  {
    path: AppRoutes.BrowserWindow.url,
    data: { ...routeInfo([AppRoutes.BrowserWindow]) },
    loadComponent: () =>
      import('./modules/gestione/components/browser-window/browser-window-home.component').then(
        (m) => m.BrowserWindowHomeComponent
      ),
    canActivate: [NoRouteDataAutoLoginPartialRouteGuardFunction],
    loadChildren: () => import('./modules/gestione/gestione-routing.module').then((m) => m.routes)
  },
  {
    path: AppRoutes.Normalizzazione.url,
    data: { ...routeInfo([AppRoutes.Normalizzazione], NormalizzazioneEMC) },
    loadComponent: () =>
      import('./modules/home-inner/components/home-inner/home-inner.component').then((m) => m.HomeInnerComponent),
    canActivate: [NoRouteDataAutoLoginPartialRouteGuardFunction],
    loadChildren: () => import('./modules/normalizzazione/normalizzazione-routing.module').then((m) => m.routes)
  },
  {
    path: AppRoutes.Giudici.url,
    data: { ...routeInfo([AppRoutes.Giudici], GiudiciEMC) },
    loadComponent: () =>
      import('./modules/home-inner/components/home-inner/home-inner.component').then((m) => m.HomeInnerComponent),
    canActivate: [NoRouteDataAutoLoginPartialRouteGuardFunction],
    loadChildren: () => import('./modules/giudici/giudici-routing.module').then((m) => m.routes)
  },
  {
    path: AppRoutes.Antidoping.url,
    data: { ...routeInfo([AppRoutes.Antidoping], AntidopingEMC) },
    loadComponent: () =>
      import('./modules/home-inner/components/home-inner/home-inner.component').then((m) => m.HomeInnerComponent),
    canActivate: [NoRouteDataAutoLoginPartialRouteGuardFunction], //canActivate: [NavigateGuard],
    loadChildren: () => import('./modules/antidoping/antidoping-routing.module').then((m) => m.routes)
  },
  {
    path: AppRoutes.Pagamenti.url,
    data: { ...routeInfo([AppRoutes.Pagamenti], PagamentiEMC) },
    loadComponent: () =>
      import('./modules/home-inner/components/home-inner/home-inner.component').then((m) => m.HomeInnerComponent),
    canActivate: [NoRouteDataAutoLoginPartialRouteGuardFunction],
    loadChildren: () => import('./modules/pagamenti/pagamenti-routing.module').then((m) => m.routes)
  },
  {
    path: AppRoutes.ProfiloUtente.url,
    data: { ...routeInfo([AppRoutes.ProfiloUtente], ProfiloUtenteEMC) },
    loadComponent: () =>
      import('./modules/home-inner/components/home-inner/home-inner.component').then((m) => m.HomeInnerComponent),
    canActivate: [NoRouteDataAutoLoginPartialRouteGuardFunction], //canActivate: [NavigateGuard],
    loadChildren: () => import('./modules/profilo-utente/profilo-utente-routing.module').then((m) => m.routes)
  },
  {
    path: AppRoutes.Formazione.url,
    data: { ...routeInfo([AppRoutes.Formazione]) },
    loadComponent: () =>
      import('./modules/home-inner/components/home-inner/home-inner.component').then((m) => m.HomeInnerComponent),
    canActivate: [NoRouteDataAutoLoginPartialRouteGuardFunction],
    loadChildren: () => import('./modules/formazione/formazione-routing.module').then((m) => m.routes)
  },
  {
    path: AppRoutes.GiudiceProfilo.url,
    data: { ...routeInfo([AppRoutes.GiudiceProfilo], GiudiceProfiloEMC) },
    loadComponent: () =>
      import('./modules/home-inner/components/home-inner/home-inner.component').then((m) => m.HomeInnerComponent),
    canActivate: [NoRouteDataAutoLoginPartialRouteGuardFunction],
    loadChildren: () => import('./modules/giudice-profilo/giudice-profilo-routing.module').then((m) => m.routes)
  },
  {
    path: AppRoutes.Corsi.url,
    data: { ...routeInfo([AppRoutes.Corsi], CorsiEMC) },
    loadComponent: () =>
      import('./modules/home-inner/components/home-inner/home-inner.component').then((m) => m.HomeInnerComponent),
    canActivate: [NoRouteDataAutoLoginPartialRouteGuardFunction],
    loadChildren: () => import('./modules/corsi/corsi-routing.module').then((m) => m.routes)
  },
  {
    path: AppRoutes.Servizi.url,
    data: { ...routeInfo([AppRoutes.Servizi], ServiziEMC) },
    loadComponent: () =>
      import('./modules/home-inner/components/home-inner/home-inner.component').then((m) => m.HomeInnerComponent),
    canActivate: [NoRouteDataAutoLoginPartialRouteGuardFunction],
    loadChildren: () => import('./modules/servizi/servizi-routing.module').then((m) => m.routes)
  },
  {
    path: AppRoutes.AnaClub.url,
    data: { ...routeInfo([AppRoutes.AnaClub], AnaClubEMC) },
    loadComponent: () =>
      import('./modules/home-inner/components/home-inner/home-inner.component').then((m) => m.HomeInnerComponent),
    canActivate: [NoRouteDataAutoLoginPartialRouteGuardFunction],
    loadChildren: () => import('./modules/ana-club/ana-club-routing.module').then((m) => m.routes)
  },
  {
    path: AppRoutes.Fatture.url,
    data: { ...routeInfo([AppRoutes.Fatture], FattureEMC) },
    loadComponent: () =>
      import('./modules/home-inner/components/home-inner/home-inner.component').then((m) => m.HomeInnerComponent),
    canActivate: [NoRouteDataAutoLoginPartialRouteGuardFunction],
    loadChildren: () => import('./modules/fatture/fatture-routing.module').then((m) => m.routes)
  },
  {
    path: AppRoutes.UnauthorizedUser.url,
    data: { ...routeInfo([AppRoutes.UnauthorizedUser]) },
    loadComponent: () =>
      import('./modules/components/unauthorized-user/unauthorized-user.component').then(
        (m) => m.UnauthorizedUserComponent
      )
  },
  {
    path: AppRoutes.Rendicontazione.url,
    data: { ...routeInfo([AppRoutes.Rendicontazione], RendicontazioneEMC) },
    loadComponent: () =>
      import('./modules/home-inner/components/home-inner/home-inner.component').then((m) => m.HomeInnerComponent),
    canActivate: [NoRouteDataAutoLoginPartialRouteGuardFunction],
    loadChildren: () => import('./modules/rendicontazione/rendicontazione-routing.module').then((m) => m.routes)
  },
  {
    path: AppRoutes.Diplomi.url,
    data: { ...routeInfo([AppRoutes.Diplomi], DiplomiEMC) },
    loadComponent: () =>
      import('./modules/home-inner/components/home-inner/home-inner.component').then((m) => m.HomeInnerComponent),
    canActivate: [NoRouteDataAutoLoginPartialRouteGuardFunction],
    loadChildren: () => import('./modules/diplomi/diplomi-routing.module').then((m) => m.routes)
  }
];

export { routes };
